<template>
  <div class="hello">
    <b-row>
    <b-list-group>
      <b-list-group-item style="text-align: center">
        <strong>History</strong><br>
        Fri Aug 31 09:35:43<br>
        GMT+05:30 2020
      </b-list-group-item>
      <b-list-group-item><img src="img/diceblue.gif" /> ITEMVIEW</b-list-group-item>
      <b-list-group-item><img src="img/filterblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
      <b-list-group-item><img src="img/viewfilterblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
      <b-list-group-item><img src="img/viewfilterblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
      <b-list-group-item><img src="img/viewfilterblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
      <b-list-group-item><img src="img/viewfilterblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
      <b-list-group-item><img src="img/diceblue.gif" /> ITEMVIEW</b-list-group-item>
      <b-list-group-item><img src="img/diceblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
      <b-list-group-item><img src="img/diceblue.gif" /> PURCHASEREQUISITIONVIEW</b-list-group-item>
    </b-list-group>
  </b-row>
  </div>
</template>

<script>
export default {
  name: 'HistoryNav',
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.list-group{
      margin-left: 25px;
    margin-top: 15px;
    border: 1px solid #333;
}
.list-group-item{
  background: transparent;
  text-align: left;
      border: 2px solid #fff;
    padding: 0rem;
    font-size: 12px;
    font-weight: 600;
}
.list-group-item img{
  border-right: 2px solid #fff;
}
</style>
